export { NotificationCountService } from './services/count';
export { NotificationListService } from './services/list';
export { NotificationService } from './services/notification';
export { NotificationSocketService } from './services/notification-socket';
export { PendingDecisionService } from './services/pending-decision';
export type { Notification, NotificationBody } from './stores/notification';
export { NotificationType } from './stores/notification';
export type {
  PendingDecision,
  RelationCandidate,
} from './stores/pending-decision';
export { NotificationRealtimeBootstrap } from './views/realtime-bootstrap';

import type { Framework } from '@toeverything/infra';

import {
  AuthService,
  GraphQLService,
  ServerScope,
  ServerService,
} from '../cloud';
import { NavigationPanelRevealService } from '../navigation-panel';
import { GlobalSessionState } from '../storage';
import { NotificationCountService } from './services/count';
import { NotificationListService } from './services/list';
import { NotificationService } from './services/notification';
import { NotificationSocketService } from './services/notification-socket';
import { PendingDecisionService } from './services/pending-decision';
import { NotificationStore } from './stores/notification';
import { PendingDecisionStore } from './stores/pending-decision';

export function configureNotificationModule(framework: Framework) {
  framework
    .scope(ServerScope)
    .service(NotificationService, [NotificationStore])
    .service(NotificationCountService, [NotificationStore, AuthService])
    .service(NotificationListService, [
      NotificationStore,
      NotificationCountService,
    ])
    .store(NotificationStore, [
      GraphQLService,
      ServerService,
      GlobalSessionState,
    ])
    // sl-fdwa.3.1: Real-time notification socket
    .service(NotificationSocketService, [
      ServerService,
      AuthService,
      NotificationCountService,
      NotificationListService,
      NavigationPanelRevealService,
    ])
    // PendingDecision services
    .store(PendingDecisionStore, [GraphQLService])
    .service(PendingDecisionService, [PendingDecisionStore]);
}
